export * from './ActorRdfMetadataExtractVoid';
